<div
    id="dashboard-sidebar-client"
    class="row align-items-center background-tertiary mb-2 mb-sm-5 padding-container-static">
    <svg-icon id="client-info-icon" class="d-none d-sm-block col-auto" src="assets/icons/Firma.svg"></svg-icon>
    <div id="client-info" class="col">
        <div id="client-info-fullname" class="t-14 t-md-15 t-sb text-secondary">{{ representative?.clientName }}</div>
        <div id="client-info-cis" class="t-13 mt-1">CIS: {{ representative?.clientCis }}</div>
    </div>
</div>
